import(/* webpackMode: "eager" */ "/app/apps/home/src/app/[locale]/error.tsx");
